import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    ContainersExportExcelParamsT,
    GetContainersParams,
    GetContainersResponse,
    ContainersExportExcelResponseT,
    GetInvoiceResponse,
} from '@/new-services/types/containers'

type ApiGetContainersResponse = Promise<AxiosResponse<GetContainersResponse>>
type ApiGetInvoiceResponse = Promise<AxiosResponse<GetInvoiceResponse>>
type ApiExportExcelResponse = Promise<AxiosResponse<ContainersExportExcelResponseT>>

export function getContainers(params: GetContainersParams): ApiGetContainersResponse {
    return http.get('/dispatcher/api/containers/paginated', { params })
}

export function getInvoice(invoiceId: number): ApiGetInvoiceResponse {
    return http.get(`/dispatcher/api/containers/invoice/${invoiceId}`, { params: { invoiceId } })
}

export function exportExcel(params: ContainersExportExcelParamsT): ApiExportExcelResponse {
    return http.get('/dispatcher/api/containers/export', { responseType: 'blob', params })
}

export default {
    getContainers,
    exportExcel,
    getInvoice,
}
